// extracted by mini-css-extract-plugin
module.exports = {"action":"Action_action__Wxy55","wrap":"Action_wrap__qjlv_","badge":"Action_badge__En_CO"};